import { render } from "./DropdownStocks.vue?vue&type=template&id=87d7cac2"
import script from "./DropdownStocks.vue?vue&type=script&lang=ts"
export * from "./DropdownStocks.vue?vue&type=script&lang=ts"
script.render = render

export default script